// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__fabMt {
  margin: 0;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;
  font-size: 1.15rem; }

.styles_titleContainer__ZTZSl {
  min-height: 3.6rem;
  padding: 0.35rem 0.25rem;
  gap: 0.5rem;
  overflow: visible; }

.styles_container__mrsGh {
  width: 100%;
  height: 5.4rem;
  min-height: 5.4rem;
  margin: 0.6rem auto;
  box-sizing: border-box; }
  .styles_container__mrsGh > div:first-child {
    margin-bottom: unset;
    cursor: pointer;
    height: 5.4rem;
    max-height: unset;
    display: flex;
    align-items: center;
    padding: 0.35rem 0.75rem;
    box-sizing: border-box; }
  .styles_container__mrsGh > div:not(:first-child) {
    padding: unset; }
  .styles_container__mrsGh .styles_textContainer__9GOhT {
    border: 1px solid #808080b8;
    border-radius: 0.9rem; }

.styles_options__Xs\\+9x {
  width: 100%; }
  .styles_options__Xs\\+9x > div button {
    font-size: 0.72rem;
    padding: 0rem 0.5rem !important;
    margin: 0.25rem; }

.styles_sabbatical__5VS2W {
  border: 1px solid #723618;
  width: 100%; }
  .styles_sabbatical__5VS2W h4 {
    text-decoration: underline;
    text-decoration-color: #723618;
    font-weight: 700; }
`, "",{"version":3,"sources":["webpack://./src/modules/cycles/components/CycleActivity/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,iBAAiB,EAAA;;AAGnB;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB,EAAA;EALxB;IAQI,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,sBAAsB,EAAA;EAf1B;IAmBI,cAAc,EAAA;EAnBlB;IAuBI,2BC1Bc;ID2Bd,qBAAqB,EAAA;;AAIzB;EACE,WAAW,EAAA;EADb;IAII,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe,EAAA;;AAInB;EACE,yBCVsB;EDWtB,WAAW,EAAA;EAFb;IAKI,0BAA0B;IAC1B,8BCfoB;IDgBpB,gBAAgB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.title {\n  margin: 0;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1.3;\n  font-size: 1.15rem;\n}\n\n.titleContainer {\n  min-height: 3.6rem;\n  padding: 0.35rem 0.25rem;\n  gap: 0.5rem;\n  overflow: visible;\n}\n\n.container {\n  width: 100%;\n  height: 5.4rem;\n  min-height: 5.4rem;\n  margin: 0.6rem auto;\n  box-sizing: border-box;\n\n  &>div:first-child {\n    margin-bottom: unset;\n    cursor: pointer;\n    height: 5.4rem;\n    max-height: unset;\n    display: flex;\n    align-items: center;\n    padding: 0.35rem 0.75rem;\n    box-sizing: border-box;\n  }\n\n  &>div:not(:first-child) {\n    padding: unset;\n  }\n\n  .textContainer {\n    border: 1px solid $grey72;\n    border-radius: 0.9rem;\n  }\n}\n\n.options {\n  width: 100%;\n\n  &>div button {\n    font-size: 0.72rem;\n    padding: 0rem 0.5rem !important;\n    margin: 0.25rem;\n  }\n}\n\n.sabbatical {\n  border: 1px solid $success_street;\n  width: 100%;\n\n  & h4 {\n    text-decoration: underline;\n    text-decoration-color: $success_street;\n    font-weight: 700;\n  }\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__fabMt`,
	"titleContainer": `styles_titleContainer__ZTZSl`,
	"container": `styles_container__mrsGh`,
	"textContainer": `styles_textContainer__9GOhT`,
	"options": `styles_options__Xs+9x`,
	"sabbatical": `styles_sabbatical__5VS2W`
};
export default ___CSS_LOADER_EXPORT___;
